// FAQ.js

import Breadcrumbs from "../../01-atoms/breadcrumbs/Breadcrumbs";

const FAQs = (props) => {
    const { dataArray } = props;

    // Filtering data to get an array of product category
    const faqArray = dataArray.filter((data) => data.fields.contentType === 'FAQs');

    // handleAccordion function
    const handleAccordion = (event) => {
        const clickedAccordion = event.target;
        const allAccordions = document.querySelectorAll('.faq-page__question--question');

        allAccordions.forEach((accordion) => {
            if (accordion !== clickedAccordion && accordion.classList.contains('open')) {
                accordion.classList.remove('open');
            }
        })

        clickedAccordion.classList.toggle('open');
    }

    return (
        <main className="secondary-page__content">
            <div className="wrapper wrapper-secondary">
                <Breadcrumbs />
                
                <div className="content-container">
                    <div className="faq-page">
                        <div className="faq-page__heading secondary-page__heading">
                            <h2>FAQs</h2>
                        </div>

                        <div className="faq-page__content">
                            {faqArray.map((faq) => {
                                return (
                                    <div key={faq.sys.id} className="faq-page__question">
                                        <div className="faq-page__question--question" onClick={handleAccordion}>{faq.fields.question}</div>
                                        <p>{faq.fields.answer}</p>
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                </div>
            </div>
        </main>
    )
}

export default FAQs;